import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Phone, Mail, Check, Inbox } from "lucide-react";
import api from "../../lib/api";

const LeadsPanel = () => {
  const [leads, setLeads] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = () => {
    setLoading(true);
    api.get("/leads").then((r) => setLeads(r.data)).finally(() => setLoading(false));
  };
  useEffect(() => { load(); }, []);

  const markContacted = async (id) => {
    await api.patch(`/leads/${id}`);
    toast.success("Marked as contacted");
    load();
  };

  if (loading) return <div className="h-40 rounded-xl bg-stone-100 animate-pulse" />;
  if (leads.length === 0) return (
    <div className="text-center py-20 border border-dashed border-stone-300 rounded-2xl" data-testid="no-leads">
      <Inbox className="mx-auto text-stone-300 mb-3" size={36} />
      <p className="font-heading text-xl text-stone-800">No enquiries yet</p>
      <p className="text-stone-500 mt-1">Buyer enquiries from your website will show up here.</p>
    </div>
  );

  return (
    <div className="bg-white rounded-2xl border border-stone-200 overflow-hidden" data-testid="leads-panel">
      <div className="overflow-x-auto">
        <table className="w-full text-sm">
          <thead>
            <tr className="text-left text-stone-500 border-b border-stone-200 bg-stone-50">
              <th className="p-4 font-medium">Buyer</th>
              <th className="p-4 font-medium">Enquiry about</th>
              <th className="p-4 font-medium">Message</th>
              <th className="p-4 font-medium">Date</th>
              <th className="p-4 font-medium text-right">Status</th>
            </tr>
          </thead>
          <tbody>
            {leads.map((l) => (
              <tr key={l.id} className="border-b border-stone-100 last:border-0 align-top" data-testid={`lead-${l.id}`}>
                <td className="p-4">
                  <p className="font-medium text-stone-800">{l.name}</p>
                  <a href={`tel:${l.phone}`} className="flex items-center gap-1 text-xs text-stone-500 mt-0.5 hover:text-brand"><Phone size={12} /> {l.phone}</a>
                  {l.email && <a href={`mailto:${l.email}`} className="flex items-center gap-1 text-xs text-stone-500 hover:text-brand"><Mail size={12} /> {l.email}</a>}
                </td>
                <td className="p-4 text-stone-600">
                  {l.intent && <span className="inline-block rounded-full bg-accent text-brand text-[11px] font-semibold px-2 py-0.5 mr-1 capitalize">{l.intent}</span>}
                  {l.property_title || l.locality || "General"}
                </td>
                <td className="p-4 text-stone-600 max-w-xs">{l.message || "—"}</td>
                <td className="p-4 text-stone-500 whitespace-nowrap">{new Date(l.created_at).toLocaleDateString("en-IN", { day: "numeric", month: "short" })}</td>
                <td className="p-4 text-right">
                  {l.status === "contacted" ? (
                    <span className="rounded-full bg-green-100 text-green-700 text-xs font-medium px-2.5 py-1">Contacted</span>
                  ) : (
                    <button onClick={() => markContacted(l.id)} data-testid={`mark-contacted-${l.id}`}
                      className="inline-flex items-center gap-1 rounded-full border border-stone-200 px-3 py-1.5 text-xs font-medium hover:border-brand transition-colors">
                      <Check size={13} /> Mark done
                    </button>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default LeadsPanel;
